<template>
  <v-card
    flat
    color="rgb(237 237 237)"
    height="98%"
    class="d-flex flex-row rounded-lg"
  >
    <v-card-text
      class="d-flex flex-column align-start justify-space-around px-3"
    >
      <div>
        <span class="text-subtitle-2">
          {{ title }}
        </span>
        <h1 :class="percent.class" class="text-h5">
          {{ percent.value }}
        </h1>
      </div>
      <div v-if="percentsSold">
        <span v-if="percentsSold.text" class="text-subtitle-2">
          {{ percentsSold.text }}
        </span>
        <h1 v-if="percentsSold.values" class="positive-percent text-h5">
          {{ percentsSold.values }}
        </h1>
      </div>
    </v-card-text>
    <v-card-text
      style="background-color: #cdccd1; width: 400px"
      class="d-flex flex-column align-start justify-space-around px-2 rounded-lg"
    >
      <div
        class="mb-2 d-flex flex-row justify-space-between align-center"
        style="width: 100%"
      >
        <span v-if="percentMobile.text" class="text-subtitle-2">
          {{ percentMobile.text }}
        </span>
        <h1 v-if="percentMobile.values" class="positive-percent text-subtitle">
          {{ percentMobile.values }}
        </h1>
      </div>
      <div
        class="mb-2 d-flex flex-row justify-space-between align-center"
        style="width: 100%"
      >
        <span
          v-if="todayMobile.text"
          class="text-subtitle-2"
          style="max-width: 100px"
        >
          {{ todayMobile.text }}
        </span>
        <h1 v-if="todayMobile.values" class="positive-percent text-subtitle">
          {{ todayMobile.values }}
        </h1>
      </div>
      <div
        class="mb-2 d-flex flex-row justify-space-between align-center"
        style="width: 100%"
      >
        <span v-if="ticketsAvailable.text" class="text-subtitle-2">
          {{ ticketsAvailable.text }}
        </span>
        <h1
          v-if="ticketsAvailable.values"
          class="positive-percent text-subtitle"
        >
          {{ ticketsAvailable.values }}
        </h1>
      </div>
      <div
        class="mb-2 d-flex flex-row justify-space-between align-center"
        style="width: 100%"
      >
        <span v-if="averageTicket.text" class="text-subtitle-2">
          {{ averageTicket.text }}
        </span>
        <h1 v-if="averageTicket.values" class="positive-percent text-subtitle">
          {{ averageTicket.values }}
        </h1>
      </div>
      <div
        class="mb-2 d-flex flex-row justify-space-between align-center"
        style="width: 100%"
      >
        <span v-if="cortesyEmit.text" class="text-subtitle-2">
          {{ cortesyEmit.text }}
        </span>
        <h1 v-if="cortesyEmit.values" class="positive-percent text-subtitle">
          {{ cortesyEmit.values }}
        </h1>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import displayHelpers from "@/mixins/breakpoints.mixins";
export default {
  name: "DashCardMobile",
  mixins: [displayHelpers],
  props: {
    refreshInfo: {
      type: String,
      required: false,
      default: "",
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "base",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: true,
    },
    information: {
      type: Object,
      required: false,
      default: () => {},
    },
    percent: {
      required: false,
    },
    percentMobile: {
      type: Object,
      required: false,
      default: () => {},
    },
    todayMobile: {
      type: Object,
      required: false,
      default: () => {},
    },
    ticketsAvailable: {
      required: false,
    },
    averageTicket: {
      type: Object,
      required: false,
      default: () => {},
    },
    cortesyEmit: {
      type: Object,
      required: false,
      default: () => {},
    },
    percentsSold: {
      required: false,
    },
    fillHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
    table: {
      type: Boolean,
      required: false,
      default: false,
    },
    headers: {
      type: Array,
      required: false,
      default: () => [],
    },
    list: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    info: {
      type: String,
      required: false,
      default: () => "",
    },
    click: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.dash-card {
  border-radius: 15px;
  margin-top: 0.5rem;
  position: relative;
}
.positive-percent {
  color: #572c88;
  font-size: 1rem;
}

.negative-percent {
  color: #d70200;
  font-size: 0.875rem;
}

/* .checkin-percent {
  padding: 0px 10px !important;
} */
</style>
